<div class="redirect-page-wrapper">
    <p-toast></p-toast>
    <div class="redirect-page-inner">
        <div class="redirect-page-logo">
            <img
                src="assets/demo/images/champ.png"
                alt="Champions logo"
                class="mb-4 w-6rem flex-shrink-0"
            />
        </div>
        <div class="redirect-page-content mt-2">
            <span class="message-text mb-2"
                >Click on the button below to check your payment status</span
            >
            <div
                class="flex align-items-center my-4 justify-content-center w-full"
            >
                <button pButton (click)="checkStatus()">
                    Refresh payment status
                </button>
            </div>
            <p *ngIf="loading">Loading...</p>
            <div class="response-container" *ngIf="response">
                <div class="response-data">
                    <span class="title">Status</span>
                    <span>{{response.status}}</span>
                </div>
                <div class="response-data">
                    <span class="title">Message</span>
                    <span>{{response.message}}</span>
                </div>
                <div class="response-data">
                    <span class="title">Provider Ref</span>
                    <span>{{response}}</span>
                </div>
                <div class="response-data mt-4">
                    <a [href]="response.redirectUrl"><i class="pi pi-arrow-left"></i>&nbsp;Go back to payment</a>
                </div>
            </div>
        </div>
    </div>
</div>
